export default __webpack_public_path__ + "static/media/kitchen5-afterA-2048w.03c9673b.avif";